import { useEffect, useRef } from "react";
import { C } from "../constants";

export default function LegalPage({ title, subtitle, lastUpdated, sections, onBack, accentColor }) {
  const scrollRef = useRef();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "smooth" }); }, []);

  return (
    <div style={{ animation:"fadeUp .4s ease both" }}>
      <button onClick={onBack}
        style={{ background:"transparent", border:`1px solid ${C.border}`, color:C.muted, borderRadius:8, padding:"6px 14px", fontSize:12, cursor:"pointer", fontFamily:"'Space Mono',monospace", marginBottom:32, display:"inline-flex", alignItems:"center", gap:6 }}>
        ← Back to Home
      </button>
      <div style={{ marginBottom:48 }}>
        <div style={{ display:"inline-flex", alignItems:"center", gap:8, background:C.accentSoft, border:`1px solid ${C.accent}40`, borderRadius:20, padding:"5px 16px", fontSize:11, fontFamily:"'Space Mono',monospace", color:C.accent, letterSpacing:"0.07em", textTransform:"uppercase", marginBottom:18 }}>
          💘 Get Resumatch
        </div>
        <h1 style={{ fontFamily:"'Playfair Display',serif", fontWeight:800, fontSize:"clamp(34px,5vw,56px)", letterSpacing:"-0.03em", margin:"0 0 14px", lineHeight:1.1 }}>
          {title}
        </h1>
        <p style={{ color:C.sub, fontSize:16, maxWidth:560, margin:"0 0 10px", lineHeight:1.7 }}>{subtitle}</p>
        <p style={{ color:C.muted, fontSize:12, fontFamily:"'Space Mono',monospace", margin:0 }}>
          Last updated: {lastUpdated} · Questions? <a href="mailto:support@getresumatch.com" style={{ color:C.accent, textDecoration:"none" }}>support@getresumatch.com</a>
        </p>
      </div>
      <div style={{ background:C.surface, border:`1px solid ${C.border}`, borderRadius:16, padding:"20px 24px", marginBottom:40 }}>
        <div style={{ fontSize:11, color:C.muted, fontFamily:"'Space Mono',monospace", textTransform:"uppercase", letterSpacing:"0.08em", marginBottom:12 }}>Contents</div>
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"6px 24px" }}>
          {sections.map((s, i) => (
            <a key={i} href={`#section-${i}`}
              style={{ fontSize:13, color:C.sub, textDecoration:"none", display:"flex", alignItems:"center", gap:8, padding:"3px 0" }}
              onMouseEnter={e => e.currentTarget.style.color = C.accent}
              onMouseLeave={e => e.currentTarget.style.color = C.sub}>
              <span style={{ fontFamily:"'Space Mono',monospace", fontSize:10, color:C.accent }}>{String(i+1).padStart(2,"0")}</span>
              {s.title}
            </a>
          ))}
        </div>
      </div>
      <div ref={scrollRef} style={{ display:"flex", flexDirection:"column", gap:40 }}>
        {sections.map((section, i) => (
          <div key={i} id={`section-${i}`} style={{ scrollMarginTop: 80 }}>
            <div style={{ display:"flex", alignItems:"center", gap:12, marginBottom:20 }}>
              <span style={{ fontFamily:"'Space Mono',monospace", fontSize:11, color:C.accent }}>{String(i+1).padStart(2,"0")}</span>
              <h2 style={{ fontFamily:"'Playfair Display',serif", fontWeight:700, fontSize:22, margin:0, letterSpacing:"-0.02em" }}>
                {section.title}
              </h2>
              <div style={{ flex:1, height:1, background:C.border }}/>
            </div>
            <div style={{ display:"flex", flexDirection:"column", gap:16 }}>
              {section.content.map((item, j) => (
                <div key={j} style={{ background:C.surface, border:`1px solid ${C.border}`, borderRadius:14, padding:"20px 22px" }}>
                  {item.heading && (
                    <div style={{ fontWeight:700, fontSize:14, color:C.text, marginBottom:8, display:"flex", alignItems:"center", gap:8 }}>
                      <span style={{ width:6, height:6, borderRadius:"50%", background:C.accent, display:"inline-block", flexShrink:0 }}/>
                      {item.heading}
                    </div>
                  )}
                  <p style={{ color:C.sub, fontSize:14, lineHeight:1.75, margin:0 }}>{item.body}</p>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
      <div style={{ marginTop:56, background:"#1a1a2e", borderRadius:20, padding:"32px 36px", display:"flex", alignItems:"center", justifyContent:"space-between", flexWrap:"wrap", gap:20 }}>
        <div>
          <div style={{ fontFamily:"'Playfair Display',serif", fontWeight:700, fontSize:18, color:"#fff", marginBottom:6 }}>Questions about this policy?</div>
          <p style={{ color:"rgba(255,255,255,0.5)", fontSize:13, margin:0 }}>Our team is happy to help. Reach out anytime.</p>
        </div>
        <a href="mailto:support@getresumatch.com"
          style={{ background:`linear-gradient(135deg,${C.accent},#c0392b)`, color:"#fff", border:"none", borderRadius:10, padding:"12px 24px", fontSize:13, fontWeight:700, cursor:"pointer", textDecoration:"none", whiteSpace:"nowrap", boxShadow:`0 0 24px ${C.accentGlow}` }}>
          support@getresumatch.com →
        </a>
      </div>
    </div>
  );
}
